import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditEmployee } from "./FormEditEmployee";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

export const PanelEditEmployee = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [permissions,setPermissions] = useState([]);
  const [data, setData] = useState({
    name: "",
    role: "",
    email: "",
    photo: null,
    active: 1,
    password: "",
    password_confirmation: "",
    permissions: [],
  });

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Employees.GetOne}${id}`,
      });

      if (response) {
        setData({
          name: response.data.name || "",
          role: response.data.role || "",
          email: response.data.email || "",
          photo: response.data.photo || "",
          active: response.data.active ? 1 : 0,
          password: "",
          password_confirmation: "",
          permissions: response.data.permissions || [],
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getPermissions = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Permissions.View}`,
      });
      if (response){
          setPermissions(response.data)
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData();
    getPermissions();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Employee <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Employee: {data?.name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditEmployee data={data} permissions={permissions} setData={setData} />
          )
        }
      />
    </div>
  );
};
